"use strict";

var _slicedToArray = require("/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoginStateManager = void 0;

var react_1 = require("react");

var useLoginStateManager = function useLoginStateManager(liff) {
  var _a = liff !== null && liff !== void 0 ? liff : {},
      _a$isLoggedIn = _a.isLoggedIn,
      isLoggedIn = _a$isLoggedIn === void 0 ? function () {
    return false;
  } : _a$isLoggedIn,
      _a$login = _a.login,
      login = _a$login === void 0 ? function () {} : _a$login,
      _a$logout = _a.logout,
      logout = _a$logout === void 0 ? function () {} : _a$logout,
      rest = __rest(_a, ["isLoggedIn", "login", "logout"]);

  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      loginState = _ref2[0],
      setLoginState = _ref2[1];

  (0, react_1.useEffect)(function () {
    setLoginState(isLoggedIn());
  }, [isLoggedIn]);

  var customLogin = function customLogin() {
    login();
    setLoginState(isLoggedIn());
  };

  var customLogout = function customLogout() {
    logout();
    setLoginState(isLoggedIn());
  };

  return [loginState, Object.assign(Object.assign({}, rest), {
    isLoggedIn: isLoggedIn,
    login: customLogin,
    logout: customLogout
  })];
};

exports.useLoginStateManager = useLoginStateManager;